import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { CURRENCIES } from "@utils/Constants";

const CreditOperatorFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "number",
                        "name": "codigo",
                        "label": "Codigo",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 2
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "currency_id",
                        "label": "Moneda",
                        "options": CURRENCIES,
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "number",
                        "isDecimal": true,
                        "name": "exchange_rate",
                        "min": "0",
                        "step": "0.01",
                        "label": "Valor Tipo de Cambio",
                        "options": CURRENCIES,
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "is_default",
                        "label": "Moneda por defecto",
                        "sizing": {
                            "sm": {
                                "offset": "2"
                            }
                        },
                    },
                ],
            ]
        }
    ],
};


export default CreditOperatorFormConfig;